export const AGE_RANGE_ALERT_MESSAGE =
  '나이대는 본인 나이를 포함한 범위만 설정할 수 있어요.';
export const FIX_GATHERING_ALERT_MESSAGE =
  '모임이 확정된 시작 시각과 장소를 입력해주세요.';
export const UNFIX_GATHERING_ALERT_MESSAGE =
  '취소하는 경우 모임의 확정 상태가 취소되며, 모임에서 나갈 수 있어요.';
export const CHAT_IN_GATHERING_ALERT_MESSAGE = '님이 입장했습니다.';
export const CHAT_FIX_GATHERING_ALERT_MESSAGE =
  '모임이 확정되었습니다. (취소는 모임 소개 페이지에서 가능합니다.)';
export const CHAT_UNFIX_GATHERING_ALERT_MESSAGE = '님이 모임을 취소했습니다.';
export const CHAT_OUT_GATHERING_ALERT_MESSAGE = '님이 나갔습니다.';
export const CHAT_KICK_USER_ALERT_MESSAGE = '님이 강퇴 되었습니다.';
export const CREATE_TIP_ALERT_MESSAGE =
  '게임 당 한 개의 공략을 작성할 수 있어요.';
export const CATEGORY_SELECT_ALERT_MESSAGE =
  '게임 카테고리는 3개까지 선택할 수 있어요.';

export const GATHERING_FIX_ALERT_MESSAGE =
  '모임이 확정된 시작시간과 장소를 입력해주세요.';

export const GATHERING_FIX_DATE_ALERT_MESSAGE = `날짜는 현재 시간 기준 7일 이내로 선택할 수 있어요.`;
